import React from "react";
import PageComponent from "../../components/page/page_comp";
import OtpComp from "./components/otp_comp";
const OtpPage = () => {
    return (
        PageComponent({
            showFooter: false,
            content: <OtpComp />
        })
    )
};

export default OtpPage;